export default __webpack_public_path__ + "static/1kitchencounterbench-4ce4b9a7c5a278cf17e688956273946a.png";